import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaFacebook = props => {
  if (props.id !== "_svgsocialmediafacebook") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 4c8.837 0 16 7.163 16 16s-7.163 16-16 16S4 28.837 4 20 11.163 4 20 4m2.11 7.384c-2.338 0-3.94 1.428-3.94 4.05v2.26h-2.643v3.06h2.644v7.862h3.164v-7.861h2.637l.395-3.062h-3.032v-1.956c0-.886.246-1.49 1.517-1.49l1.621-.002v-2.74a21.583 21.583 0 00-2.362-.121" fill="#202020" /></svg>;
};

SvgSocialmediaFacebook.displayName = "_svgsocialmediafacebook";
SvgSocialmediaFacebook.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaFacebook.defaultProps = {
  id: ''
};
export default SvgSocialmediaFacebook;